export const formatCellPhone = (number = '') => {
  number = number.replace(/[^\d]/g, '')
  return number
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d)/, '$1-$2')
}
